import React, { Component } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { Tabs } from "antd";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { Container } from '@material-ui/core'
import CommonTextPattern from "../Essentials/CommonTextPattern";

class AboutDescription extends Component {
  render() {
    return (
      <div style={{ marginTop: "" }}>
        {this.props.type == "about" ? (
          <About title="" />
        ) : null}
        {this.props.type == "principal-message" && (
          <CommonTextPattern
            type="PRINCIPAL_MESSAGE"
            title="Message from the Principal"
            showProfile={true}
          />
        )}
        {this.props.type == "po-message" && (
          <CommonTextPattern
            type="PROGRAMME_OFFICER_MESSAGE"
            title="Message from the Programme Officer"
            showProfile={true}
          />
        )}
        {this.props.type == "motto" ? <Vission title="Motto" /> : null}
        {this.props.type == "history" && <CommonTextPattern type="HISTORY" title="History" />}
        {this.props.type == "genesis" && <CommonTextPattern type="GENESIS" title="Genesis" />}
        {this.props.type == "symbol" && <CommonTextPattern type="SYMBOL_BADGE" title="Symbol & Badge" />}
        {this.props.type == "adopted-village" && <CommonTextPattern type="ADOPTED_VILLAGE" title="Adopted Village" />}


      </div>
    );
  }
}

export default AboutDescription;

export const About = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="About the NSS Unit, Dispur College" />
      <Container className="mb-5">
        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }} gutterBottom>
          {props.title}
        </Typography>

        {/* <Typography
                variant="h6"
                gutterBottom
            >
                History
            </Typography> */}

        <Typography variant="body1" gutterBottom>
        The National Service Scheme (NSS) Unit of Dispur College was established in the year 13.10.2001 with the aim of nurturing socially responsible and committed youth through community service and nation-building activities. The Unit is affiliated to the Gauhati University NSS Cell and functions under the guidance of the Programme Officer and in accordance with the norms and objectives laid down by the Ministry of Youth Affairs & Sports, Government of India as well as in consonance with the regulations and directives issued by the Regional Directorate of NSS, Guwahati. 
        </Typography>
        <br/>
        <Typography variant="body1" gutterBottom>
        Currently, the NSS Unit comprises of an approved strength of 100 NSS volunteers, who actively engage in various regular and special activities guided by the NSS motto “Not Me, But You.” The Unit emphasizes the holistic development of students by fostering leadership, discipline, teamwork, and a spirit of selfless service.
        </Typography>
        <br/>
        <Typography variant="body1" gutterBottom>
        The NSS Unit of Dispur College regularly organizes activities such as Cleanliness Drives, Tree Plantation Programmes, Blood Donation Camps, Health and Hygiene Awareness Campaigns, Road Safety and Traffic Awareness Campaigns, Swachh Bharat Abhiyan activities, Environmental Conservation Initiatives, Literacy Surveys and Programmes, Awareness & Social Issue Programmes, Health & Wellness Activities, Disaster Relief & Emergency Services, Personality & Leadership Development Programmes and observance of important National and International days. 
        </Typography>
       <br/>
        <Typography variant="body1" gutterBottom>
        Special NSS camps are conducted annually, focusing on community development, rural outreach, and awareness on social issues of contemporary relevance. In addition to the Special Camp, the NSS Unit of Dispur College offers volunteers opportunities to participate in national, regional and state-level camps such as National Integration Camps, Adventure Camps, Republic Day Camps, Disaster Management Camps, Leadership Development Camps, etc. as organised by the Ministry of Youth Affairs and Sports of India, NSS Regional Directorates, state governments, various ministries/ departments/ directorates/ government agencies such as Directorate of Sports/ Youth Welfare/ Youth Affairs/ Higher Education/ Civil Defence, etc., various educational/ sports/ cultural societies, etc. These experiences broaden students’ horizons, foster national unity, and strengthen leadership and social responsibility.
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
        Through Village Adoption and Community-Outreach Programmes, NSS volunteers gain first-hand exposure to societal challenges and contribute meaningfully to the upliftment of local communities. These initiatives help bridge the gap between academic learning and social responsibility, enabling students to become empathetic, informed, and active citizens.
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
        Furthermore, the Unit engages its volunteers in Capacity-Building Programmes such as Hands-on Community Projects, Skill-Building internships, Field Initiatives, and Experiential Learning Programmes offering real-world experience in social service, leadership, and grassroots development.
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
        The NSS Unit of Dispur College remains steadfast in its commitment to national integration, social harmony, and the creation of a value-based society by empowering youth through service and participation.
        </Typography>
      </Container>
    </div>
  );
};

export const History = (props) => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }} gutterBottom>
        {props.title}
      </Typography>

      <div style={{ textAlign: 'center' }}>

        <img
          src={`/images/thongnokbe.jpeg`}
          style={{ width: '500px', height: '400px' }}
        />
      </div>
      <br />

      {/* <Typography
                variant="h6"
                gutterBottom
            >
                History
            </Typography> */}

      <Typography variant="body1" gutterBottom>
        THONG NOKBE lived during the medieval period fighting against Khasi feudal oppression and restored dignity and freedom to his fellow Karbis.
      </Typography>
      <Typography variant="body1" gutterBottom>
        His exploits are glorified in folklores and legends and is adored by all Karbis as the first of their national heroes.
      </Typography>
    </div>
  );
};

export const Vission = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="Motto" />
      <Container className="mb-5">
        {/* <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Motto
        </Typography>


        <Typography variant="body1" gutterBottom>
          तेजस्विनावधीतमस्तु<br />
          Tejasvinavadhitamastu<br />
          (May our study make us illumined)
        </Typography> */}


        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Motto
        </Typography>


        <Typography variant="body1" gutterBottom>
        The motto or watchword of the National Service Scheme is “NOT ME BUT YOU”. This reflects the essence of democratic living and upholds the need for selfless service and appreciation of the other person’s point of view and also to show consideration for fellow human beings. It underlines that the welfare of an individual is ultimately dependent on the welfare of society on the whole. Therefore, it should be the aim of the NSS to demonstrate this motto in its day-to-day programme.
        </Typography>



        {/* <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          Mission
        </Typography>


        <Typography variant="body1" gutterBottom>
          <p>
            <ul>
              <li>To make teachers and the taught partners in the learning process.</li>
              <li>To promote a student friendly atmosphere for encouraging them to be self-reliant and self-employable.</li>
              <li>To promote extra-curricular activities simultaneously with curricular activities.</li>
              <li>To mould the students into socially conscious human beings.</li>

              <li>To encourage students to think globally and act locally as productive citizens, through the promotion of scientific temper and action.</li>
              <li>To foster and inculcate moral and spiritual accomplishments amongst the students.</li>
              <li>To develop a transparent and responsive administration.</li>
              <li>To undergo self-analysis and self-discovery leading to elimination of bottlenecks in the context of a holistic framework</li>
            </ul>
          </p>

        </Typography> */}


      </Container>
    </div>
  );
};

const { TabPane } = Tabs;



export const ICV = (props) => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
        {props.title}
      </Typography>

      <Typography variant="body1" gutterBottom>
        <p>
          <ol>
            <li>The Primary aim of the college is to prepare students academically for Higher Secondary and Degree Examination. </li>
            <li>To produce efficient human resource for serving for the betterment of the district in particular and to act as a conscious citizen in general. </li>

            <li>To spread higher education in the district.</li>


          </ol>
        </p>

      </Typography>


    </div>
  )
}



export const Emblem = (props) => {
  return (
    <div>
      <BreadCrumbOwn title="Emblem" />
      <Container className="mb-5">
        <Typography variant="h4" style={{ margin: "1em 0", fontWeight: 700 }}>
          {props.title}
        </Typography>

        <div>
          <img
            src="/images/prag-logo-small.png"
            style={{width: 200, marginBottom: 20}}
          />
        </div>

        <Typography variant="body1" gutterBottom>
          The conch on the eight-petaloid full-bloomed graceful lotus symbolises pure knowledge.तेजस्विनावधीतमस्तु (Tejasvinavadhitamastu), the inspiring Motto of our college, speaks: May our study make us illumined. The aims, objectives and ideals of education are epitomised in this great saying of Taittiriya Upanishad (Ch. II Brahmananda Valli, Section 1, Invocation).

        </Typography>

      </Container>


    </div>
  )
}